import Icon from '@mdi/react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@purinanbm/pds-ui';
import { sendIt } from 'gatsby-plugin-purina-analytics/common/functions';
import React from 'react';
import { mdiEarth } from 'src/assets/icons/mdiIcons';
import { isServer } from 'src/utils/environment';
import { getAnchorTarget } from 'src/utils/url';
import { BaseLink } from '../Link';

type UtilityNavAccordionsProps = {
  utilityNav: IStorageSubMenu[];
  translations?: Translations;
};

const forceMount = isServer() ? ({ forceMount: true } as const) : {};

const UtilityNavStacked: React.FC<UtilityNavAccordionsProps> = ({ utilityNav, translations }) => {
  const translationInfo = translations?.edges[0]?.node;

  return (
    <ul className="pds-m-0 pds-flex pds-flex-col pds-p-0">
      {utilityNav.map((link, index) => {
        const isAccordion = Boolean(link.links.length);

        if (isAccordion) {
          return (
            <li key={link.link.title}>
              <Accordion
                type="single"
                collapsible
                options={{ headingLevel: 'div' }}
                className="pds-py-4"
              >
                <AccordionItem value={link.link.title} className="pds-border-b-none">
                  <AccordionTrigger
                    className="pds-p-0 pds-text-body-lg pds-font-normal"
                    onClick={() => {
                      sendIt({
                        event: 'nav_click',
                        eventParams: {
                          nav_item: link.link.title,
                          nav_type: 'header',
                        },
                      });
                    }}
                  >
                    {link.link.title}
                  </AccordionTrigger>

                  <AccordionContent className="pds-p-0" role={undefined} {...forceMount}>
                    <ul className="pds-mt-4 pds-flex pds-flex-col pds-rounded pds-bg-surface-layer pds-px-4 pds-py-4 lg:pds-gap-3">
                      {link.links.map(subLink => {
                        return (
                          <li key={subLink.title}>
                            <BaseLink
                              to={subLink.url}
                              analytics={false}
                              target={getAnchorTarget(link.link.url)}
                              onClick={() => {
                                sendIt({
                                  event: 'nav_click',
                                  eventParams: {
                                    nav_item: subLink.title,
                                    nav_type: 'header',
                                  },
                                });
                              }}
                              className="pds-flex pds-max-w-[max-content] pds-items-center pds-gap-3 pds-py-3.5 pds-text-body-md pds-text-black pds-no-underline lg:pds-py-0"
                            >
                              {subLink.title}
                            </BaseLink>
                          </li>
                        );
                      })}
                    </ul>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </li>
          );
        }

        return (
          <li key={link.link.title}>
            <BaseLink
              key={index}
              to={link.link.url}
              analytics={false}
              target={getAnchorTarget(link.link.url)}
              className="pds-flex pds-max-w-[max-content] pds-items-center pds-gap-3 pds-py-4 pds-text-body-lg pds-text-surface-text pds-no-underline"
              onClick={() => {
                sendIt({
                  event: 'nav_click',
                  eventParams: {
                    nav_item: link.link.title,
                    nav_type: 'header',
                  },
                });
              }}
            >
              {link.link.title}
            </BaseLink>
          </li>
        );
      })}

      {translationInfo && (
        <li key="translation-link">
          <BaseLink
            analytics={false}
            to={translationInfo.path.alias}
            lang={translationInfo.langcode}
            onClick={() => {
              sendIt({
                event: 'nav_click',
                eventParams: {
                  nav_item: translationInfo.langcode,
                  nav_type: 'header',
                },
              });
            }}
            className="pds-inline-block pds-py-4 pds-text-body-lg pds-text-surface-text pds-no-underline"
          >
            {translationInfo.langcode === 'es' ? 'Español' : 'English'}{' '}
            <Icon path={mdiEarth} className="pds-ml-2" size={0.7} />
          </BaseLink>
        </li>
      )}
    </ul>
  );
};

export default UtilityNavStacked;
